import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeStyle as _normalizeStyle, withCtx as _withCtx } from "vue"

import { ref, withDefaults, onMounted, watch } from 'vue';
import translate from '@/api/translate';

interface main {
	id?: string | number,
	size?: string,
	placeholder?: string,
	ValueKey?: string,
	LabelKey?: string,
	width?: string | number,
	disabled?: boolean,
	list?: any,
	clearable?: boolean,
}
export default /*#__PURE__*/_defineComponent({
  __name: 'SelectModel',
  props: {
    id: { default: "" },
    size: { default: "default" },
    placeholder: { default: translate.ShowText('请选择') },
    ValueKey: { default: "value" },
    LabelKey: { default: "label" },
    width: { default: "100%" },
    disabled: { type: Boolean, default: false },
    list: { default: [] },
    clearable: { type: Boolean, default: true }
  },
  emits: ["update:id", "change", "clear"],
  setup(__props: any, { emit: __emit }) {

;

const props = __props;

const emits = __emit;
const StatusId = ref<any>("");

watch(() => props.id, (n: any) => {
	StatusId.value = n;
});

onMounted(() => {
	StatusId.value = props.id;
});

const StatusChange = (data: any) => {
	emits("update:id", data);
	emits("change", data);
};
const StatusClear = () => {
	emits("clear");
};

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!

  return (_openBlock(), _createBlock(_component_el_select, {
    "remote-show-suffix": "",
    filterable: "",
    clearable: props.clearable,
    style: _normalizeStyle({ 'width': `${_ctx.width}` }),
    disabled: _ctx.disabled,
    size: _ctx.size,
    modelValue: StatusId.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((StatusId).value = $event)),
    placeholder: _ctx.placeholder,
    onChange: StatusChange,
    onClear: StatusClear
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.list, (v) => {
        return (_openBlock(), _createBlock(_component_el_option, {
          key: v[_ctx.ValueKey],
          label: v[_ctx.LabelKey],
          value: v[_ctx.ValueKey]
        }, null, 8, ["label", "value"]))
      }), 128))
    ]),
    _: 1
  }, 8, ["clearable", "style", "disabled", "size", "modelValue", "placeholder"]))
}
}

})